<template>
    <div v-if="payload&&location">

        <input id="homedetails" v-model="homedetails" hidden>

        <!-- Top logo and contact details -->
        <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white border-bottom shadow-sm">

            <span v-if="payload.company.logo" class="">
                <img class="mr-3" height="35px" :src="payload.company.logo" :alt="payload.company.label">
            </span>

            <h5 class="my-0 mr-md-auto font-weight-normal">
                {{ payload.company.label }}
            </h5>

            <strong v-if="payload.company.phone"><a :href="'tel:'+payload.company.phone">Call {{payload.company.phone}}</a></strong>

        </div>

        <div v-if="!cookie">
            <div class="alert alert-warning alert-dismissible fade show m-0 p-2" role="alert">
            <small><strong>We use cookies.</strong> Cookies are files stored in your browser which this site uses to personalize your experience. Some sites won't work without it.</small>
            <button type="button" class="btn btn-sm btn-primary pt-0 float-right" data-dismiss="alert" aria-label="Close" v-on:click="cookies()">
                <span aria-hidden="true" class=""><small>Accept</small></span>
            </button>
            </div>
        </div>

        <!-- Header -->
        <div class="col-lg-12 col-sm-12 m-0 p-0 mb-2 bg-dark"
             style="min-height: 100%; max-width: 100%;
         background-size: cover;
         background-position: center;
         background-repeat: no-repeat;
         background-blend-mode: overlay;
         background-image: url('https://media.reallyworks.xyz/images/a/stock_house1.jpeg')">
          <span v-if="request.rw_n" class="float-right text-white mr-2"><small><strong>Welcome back {{ request.rw_n }}!</strong></small></span>
            <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center" style="max-width: 768px; min-height:150px;">
              <h1 class="display-4 text-white">{{payload.header||''}}</h1>
                <h2 class="lead text-white">{{payload.subheader||''}}</h2>
                <p v-if="payload.preferences.leads">
                    <a v-if="demo" class="btn btn-primary btn-lg m-2" href="#subscribetoseemore">Subscribe for access</a>
                    <a v-if="!demo&&request.rw_cid" v-on:click="signOut()" class="btn btn-success btn-lg m-2" href="#">Sign out.</a>
                    <a v-else class="btn btn-success btn-lg m-2" href="#" data-toggle="modal" data-target="#registered">Sign in.</a>
                </p>
            </div>
        </div>

        <div class="container">

            <!-- Alert -->
            <div v-if="alert.subscribed" class="col alert alert-warning alert-dismissible fade show" role="alert">
                <strong>Congratulations!</strong> You confirmed your subscription. Use your email to <a v-on:click="signIn()" href="#">sign in</a> from a different computer or device.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- Filters -->
            <div class="row m-3 pb-1 border-bottom">
                <div class="col">
                    <div class="row">
                        <div class="form-group mr-3">
                            <select v-model="filters.price"  @change="findPrice" class="form-control" id="selectPrice">
                                <option value="1000"> 1K+</option>
                                <option value="10000"> 10K+</option>
                                <option value="50000"> 50K+</option>
                                <option value="150000"> 150K+</option>
                                <option value="250000"> 250K+</option>
                                <option value="350000"> 350K+</option>
                                <option value="450000"> 450K+</option>
                                <option value="500000"> 500K+</option>
                                <option value="0.01" selected> Any Price</option>
                            </select>
                        </div>

                        <div class="form-group mr-3">
                            <select v-model="filters.rooms" @change="findRooms" class="form-control" id="selectRooms">
                                <option value="1">1 Room</option>
                                <option value="2">2 Rooms</option>
                                <option value="3">3 Rooms</option>
                                <option value="4">4 Rooms</option>
                                <option value="5">5 Rooms</option>
                                <option value="0" selected>Any Rooms</option>
                            </select>
                        </div>

                        <div class="form-group mr-3">
                            <select v-model="filters.baths" @change="findBaths" class="form-control" id="selectBaths">
                                <option value="1">1 Bathrooms</option>
                                <option value="2">2 Bathrooms</option>
                                <option value="3">3 Bathrooms</option>
                                <option value="4">4 Bathrooms</option>
                                <option value="5">5 Bathrooms</option>
                                <option value="0" selected>Any Bathrooms</option>
                            </select>
                        </div>

                        <div class="form-group mr-3">
                            <select v-model="filters.type" @change="findType" class="form-control" id="selectType">
                                <option value="10">Commercial Property</option>
                                <option value="11">Condo</option>
                                <option value="12">Duplex</option>
                                <option value="13">Multi-Family</option>
                                <option value="14">Land</option>
                                <option value="15">Multiple / Condo</option>
                                <option value="16">Patio Home</option>
                                <option value="17">Quadplex</option>
                                <option value="18">Single Family</option>
                                <option value="19">Town home</option>
                                <option value="20">Triplex</option>
                                <option value="99">Any Type</option>
                            </select>
                        </div>

                        <div class="form-group mr-3">
                            <button id="resetSelect" type="button" class="form-control btn btn-outline-secondary" v-on:click="resetFilters()">Reset search</button>
                        </div>

                        <div class="form-group mr-3">
                            {{counter}} propert{{(counter > 1) ? 'ies' : 'y'}}
                        </div>

                    </div>
                </div>
            </div>

            <!-- Properties -->
            <div class="row">
                <div v-for="p in store" :key="p.slug" class="col-lg-4 col-md-6 col-sm-12">
                    <div class="card mb-4 shadow-sm">
                        <div class="xxx" style="position: relative; color: white; text-align: center;">
                            <div class="">
                            <img class="bd-placeholder-img card-img-top lazyload" width="100%" height="225px" :data-src="p.url_image_primary">
                            <div v-if="p.status===0" class="top-right"><span class="rounded-0 badge badge-light">INACTIVE</span></div>
                            <div v-else-if="p.status===1" class="top-right"><span class="rounded-0 badge badge-primary">PREVIEW</span></div>
                            <div v-else-if="p.status===2" class="top-right"><span class="rounded-0 badge badge-success" title="For Sale">AVAILABLE</span></div>
                            <div v-else-if="p.status===3" class="top-right"><span class="rounded-0 badge badge-warning" title="Processing Contract">PENDING</span></div>
                            <div v-else-if="p.status===4" class="top-right"><span class="rounded-0 badge badge-danger" title="Closed">SOLD</span></div>
                            <div v-else class="top-right"><span class="rounded-0 badge badge-warning">CALL FOR DETAILS</span></div>
                            </div>
                            <!--<img class="bd-placeholder-img card-img-top" width="100%" height="225px" :src="p.url_image_primary">-->
                            <div v-if="p.property_headline_1" class="content">
                                <small v-if="p.property_headline_1">{{p.property_headline_1.substring(0,97)}}...</small>
                                <small v-else>{{p.property_headline_1||'More details available'}}</small>
                            </div>
                        </div>
                        <div class="card-body">
                            <p class="card-title">
                                <strong v-if="p.financials_asking_price>0">{{ p.financials_asking_price | currency}}</strong>
                                <strong v-else>Call For Details</strong>
                                <br>
                                <strong class="text-black-50">{{p.property_address}}, {{p.property_city}},
                                    {{p.property_state}} {{p.property_zip}}</strong> <br>
                                <span class="text-black-50">{{p.property_rooms||0}} beds, {{p.property_bathrooms||0}} bath, {{p.property_sq_ft||0}} sq.ft</span>
                            </p>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="btn-group">
                                    <button v-if="(!payload.preferences.leads||!demo||request.rw_cid)"
                                      type="button" class="btn btn-sm btn-outline-secondary"
                                      data-toggle="modal" data-target="#viewPropertyModal"
                                    v-on:click="getProperty(p, p.slug)">View details
                                    </button>
                                    <a v-else class="btn btn-sm btn-outline-secondary" href="#subscribetoseemore">Get details</a>
                                    <!--<button type="button" class="btn btn-sm btn-outline-secondary"
                                            data-toggle="modal" data-target="#makeOfferModal">Make An Offer
                                    </button>-->
                                </div>
                                <small class="text-muted">
                                <span v-if="p.status===0">Inactive</span>
                                <span v-else-if="p.status===1">Preview</span>
                                <span v-else-if="p.status===2">Available</span>
                                <span v-else-if="p.status===3">Pending</span>
                                <span v-else-if="p.status===4">Sold</span>
                                <span v-else>Call For Details</span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                    <!-- Features -->
                    <!--<div class="col">
                        <h4 class="mt-5 mb-4">What's going on with {{ $company->title }}</h4>
                        <div class="row p-3 shadow justify-content-center">
                            <div class="col-lg-2 col-sm-6 p-1 m-2 text-center">
                                <h3 style="color: #3f9ae5">4,835</h3> Homes for sale
                            </div>
                            <div class="col-lg-2 col-sm-6 p-1 m-2 text-center">
                                <h3 style="color: #3f9ae5">4,835</h3> Open houses
                            </div>
                            <div class="col-lg-2 col-sm-6 p-1 m-2 text-center">
                                <h3 style="color: #3f9ae5">4,835</h3> Recently sold
                            </div>
                            <div class="col-lg-2 col-sm-6 p-1 m-2 text-center">
                                <h3 style="color: #3f9ae5">$50.00</h3> Undefined
                            </div>
                            <div class="col-lg-2 col-sm-6 p-1 m-2 text-center">
                                <h3 style="color: #3f9ae5">45</h3> Undefined
                            </div>
                        </div>
                    </div>-->
                </div>

            <!-- Subscribe -->    
            <span id="subscribetoseemore"></span>
            <div class="row m-1" v-if="payload.preferences.opt_in_daily||payload.preferences.opt_in_weekly||payload.preferences.opt_in_monthly||payload.preferences.opt_in_yearly">
                <div v-if="!thankYouSubscriber" class="col-12 card shadow-sm p-lg-4 p-md-2 shadow">
                    <div class="card-body">
                        <h3><strong>Subscribe To Get Access To Our Inventory List</strong></h3>
                        <p>Want to see more details? Subscribe today or <a href="#">sign in</a>.</p>
                        <!-- Subscription form -->
                        <form>
                            <div class="form-row form-group">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label for="subName">Name</label>
                                    <input v-model="subscriber.name" v-on:input="subscriberErrors.name=false" type="text" class="form-control" id="subName" placeholder="" required>
                                    <small v-if="subscriberErrors.name" class="form-text text-danger">*Your name is required.</small>
                                </div>
                                <div  class="col-lg-4 col-md-6 col-sm-12">
                                    <label for="subEmail">Email</label>
                                    <input v-model="subscriber.email" v-on:input="subscriberErrors.email=false" type="email" maxlength="55" class="form-control" id="subEmail">
                                    <small v-if="subscriberErrors.email" class="form-text text-danger">*Your email is required.</small>
                                </div>
                                <div  class="col-lg-4 col-md-6 col-sm-12">
                                    <label for="subPhone">Mobile SMS <small>(10 digit #, US Only)</small></label>
                                    <input v-model="subscriber.phone" v-on:input="subscriberErrors.phone=false" type="text" maxlength="10" class="form-control" id="subPhone" placeholder="Optional">
                                
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label for="subCompany">Company Name</label>
                                    <input v-model="subscriber.company" type="text" maxlength="55" class="form-control" id="subCompany" placeholder="Optional">
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Which best describes your interests?</label><br>
                                <div class="form-check form-check-inline">
                                    <input v-model="subscriber.interest.buyer" class="form-check-input" type="checkbox" value="true" id="subBuyer">
                                    <label class="form-check-label" for="subBuyer">Buyer</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="subscriber.interest.seller" class="form-check-input" type="checkbox" value="true" id="subSeller">
                                    <label class="form-check-label" for="subSeller">Seller</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="subscriber.interest.lender" class="form-check-input" type="checkbox" value="true" id="subLender">
                                    <label class="form-check-label" for="subLender">Lender</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="subscriber.interest.other" class="form-check-input" type="checkbox" value="true" id="subOther">
                                    <label class="form-check-label" for="subOther">Other</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Subscribe to our email newsletter to receive up-to-date property information?</label><br>
                                <div v-if="payload.preferences.opt_in_daily" class="form-check form-check-inline">
                                    <input v-model="subscriber.newsletter.daily" class="form-check-input" type="radio" name="subFreq" value="daily" id="newsDaily">
                                    <label class="form-check-label" for="newsDaily">Daily</label>
                                </div>
                                <div v-if="payload.preferences.opt_in_weekly" class="form-check form-check-inline">
                                    <input v-model="subscriber.newsletter.weekly" class="form-check-input" type="radio" name="subFreq" value="weekly" id="newsWeekly" :selected="true">
                                    <label class="form-check-label" for="newsWeekly">Weekly</label>
                                </div>
                                <div v-if="payload.preferences.opt_in_monthly" class="form-check form-check-inline">
                                    <input v-model="subscriber.newsletter.monthly" class="form-check-input" type="radio" name="subFreq" value="monthly" id="newsMonthly">
                                    <label class="form-check-label" for="newsMonthly">Monthly</label>
                                </div>
                                <div v-if="payload.preferences.opt_in_yearly" class="form-check form-check-inline">
                                    <input v-model="subscriber.newsletter.yearly" class="form-check-input" type="radio" name="subFreq" value="yearly" id="newsYearly">
                                    <label class="form-check-label" for="newsYearly">Yearly</label>
                                </div>
                            </div>
                            <hr>
                            <div class="form-check form-check-inline">
                                <input v-on:change="subscriber.ok=!subscriber.ok" class="form-check-input" type="checkbox" name="subOk" value="true">
                                <small>I agree to recieving email.</small>
                            </div>
                            <div class="pt-2">
                                <button  v-on:click="storeSubscriber(false, $event)" type="button" class="btn btn-blocl btn-primary" :disabled="this.subscriber.ok===false">Keep Me Updated</button>
                                <small>Check the Agree checkbox above if you agree to receive frequent emails from us. We will send you a confirmation email shortly. You can unsubscribe anytime. SMS & Data rates may apply.</small>

                            </div>
                        </form>
                    </div>
                </div>
                <div v-else class="card col-12 shadow-sm p-lg-5 p-md-3 shadow">
                    <div class="card-body">
                        <h3 class="text-center"><strong>You're nearly there! Check your Inbox.</strong></h3>
                      <div class="alert alert-warning" role="alert">
                        We just need to verify your email address to complete your request. If you dont see an email in your inbox please check your Spam folders.
                      </div>
                      <p class="text-center"><i class="fas fa-7x fa-envelope-open-text" style="color: grey;"></i></p>
                        <p class="text-center">
                            Please check your email or text messages to confirm your newsletter subscription options. You won't receive frequent newsletters until you confirm your subscription.
                          <br>
                          <button id="resend" type="button" class="btn btn-md btn-link mt-3"
                            v-on:click="storeSubscriber(true, $event)">
                            Didn't get the email? Click to resend
                          </button>
                        </p>
                    </div>
                </div>
            </div>

            <!-- View Property Details Modal -->
            <div v-if="details" class="modal fade" id="viewPropertyModal" tabindex="-1" role="dialog" aria-labelledby="viewPropertyModalTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered" role="document">
                    <div class="modal-content pb-3">
                        <div class="modal-header">
                            <img class="mr-3" v-if="payload.company.logo" :src="payload.company.logo" alt="" height="35px">
                            <span class="mt-1" v-if="property">{{payload.company.label}} - {{details.property_address}}, {{details.property_city}} {{details.property_state}} {{details.property_zip}} </span>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" v-on:click="details=null">&times;</span>
                            </button>
                        </div>
                        <div v-if="details" class="modal-body">
                            <div  class="row">
                                <!-- Carousel Static-->
                                <div v-if="computedImageList===null" class="col-lg-7 col-md-12 col-sm-12 mb-3 text-center">
                                    <img v-if="details.url_image_primary" :src="details.url_image_primary" width="100%" alt="No images available" class="img-fluid">
                                    <img v-else src="https://media.reallyworks.xyz/images/a/house.gif" width="100%" alt="No images available" class="img-fluid">
                                </div>
                                <!-- Carousel Multiple Images-->
                                <div v-else class="col-lg-7 col-md-12 col-sm-12 mb-3">
                                    <div id="demo" class="carousel slide carousel-fade" data-ride="false" data-interval="false" data-touch="true" data-keyboard="true">
                                        <!-- Indicators -->
                                        <ul class="carousel-indicators">
                                            <li v-for="(i, index) in computedImageList" :key="index" data-target="#demo" :data-slide-to="index" :class="{'active': index===0}"></li>
                                        </ul>
                                        <!-- The slideshow -->
                                        <div class="carousel-inner">
                                            <div v-for="(i, index) in computedImageList" :key="index" class="carousel-item" data-interval="0" :class="{'active': index===0}">
                                                <img :data-src="i" alt="Image" class="lazyload d-block w-100">
                                            </div>
                                        </div>
                                        <!-- Left and right controls -->
                                        <a class="carousel-control-prev" href="#demo" data-slide="prev">
                                            <span class="carousel-control-prev-icon"></span>
                                        </a>
                                        <a class="carousel-control-next" href="#demo" data-slide="next">
                                            <span class="carousel-control-next-icon"></span>
                                        </a>
                                    </div>
                                </div>
                                <!-- Info box -->
                                <div class="col-lg-5 col-md-12 col-sm-12 p-0 m-0">
                                    <div class="col">
                                        <h4 v-if="details">
                                            <span v-if="details.financials_asking_price > 0">{{details.financials_asking_price*1 | currency}}</span>
                                            <span v-else>Call For Details</span>
                                            <small class="ml-3">{{details.property_sq_ft || '0'}} sq.ft.</small>
                                        </h4>
                                        <p>{{details.property_address}}, {{details.property_city}} {{details.property_state}} {{details.property_zip}} ({{details.property_rooms}} beds, {{details.property_bathrooms}} baths)</p>
                                    </div>
                                    <div v-if="details.flag_contact_form===false" class="col">
                                        <img  class="img-fluid" :src="apiUrl+'api/v1/listing/map/image?long='+details.property_longitude+'&lat='+details.property_latitude" alt="Map image">
                                    </div>
                                    <div v-else class="col">
                                        <div class="form-group">
                                            <form>
                                                <input v-model="request.name" v-on:input="errors.name=null" maxlength="30" type="text" class="form-control rounded-0" aria-describedby="nameHelp" placeholder="Name" required>
                                                <small v-if="errors.name" id="nameHelp" class="form-text text-danger">{{errors.name}}.</small>
                                                <div class="col px-0">
                                                    <div class="col-sm-12 px-0">
                                                    <input v-model="request.phone" v-on:input="errors.phone=null"  maxlength="10" type="text" class="form-control mr-0 rounded-0" aria-describedby="phoneHelp" placeholder="Phone" required>
                                                    <small v-if="errors.phone" id="phoneHelp" class="form-text text-danger">{{errors.phone}}.</small>
                                                    </div>
                                                    <div class="col-sm-12 px-0">
                                                    <input v-model="request.email" v-on:input="errors.email=null" maxlength="55"  type="email" class="form-control ml-0 rounded-0" aria-describedby="emailHelp" placeholder="Enter email (optional)">
                                                    <small v-if="errors.email" id="emailHelp" class="form-text text-danger">{{errors.email}}.</small>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <textarea v-if="property" v-model="request.message" class="form-control rounded-0" maxlength="155" rows="2"></textarea>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="form-group form-check">
                                            <input v-model="request.appointment" type="checkbox" class="form-check-input" id="schedule">
                                            <label class="form-check-label" for="schedule">Call me to schedule an appointment.</label>
                                        </div>
                                        <div class="form-group form-check">
                                            <input v-model="request.additional" type="checkbox" class="form-check-input" id="confirm" aria-describedby="confirmHelp">
                                            <label class="form-check-label" for="confirm">Send me additional information (email required).</label>
                                            <small id="confirmHelp" class="form-text text-muted">
                                                By continuing, you agree to be contacted by prerecorded/artificial or live voice, email or sms based on your preferences. Message/data rates may apply.
                                            </small>
                                        </div>
                                        <button v-if="thankYou" type="button" class="btn btn-block btn-link-no-spacing">Thank you</button>
                                        <button v-else v-on:click="storeRequest()" type="submit" class="btn btn-block btn-primary">Contact {{(details.contact===" "||details.contact===null) ? 'Representative' : details.contact }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row pt-3">
                                <div class="col-md-12 col-sm-12 col-lg-6">
                                    <!-- Contact -->
                                    <div class="mb-5" v-if="details.contact==null||details.contact!==' '">
                                        <img v-if="details.contact_avatar" class="float-left rounded mr-2" :src="'https://media.reallyworks.xyz/images/p/'+details.contact_avatar+'.jpg'" width="50" alt="">
                                        <span>
                                                <strong v-if="details.contact" >Contact {{details.contact}}</strong> <br>
                                                <span v-if="details.contact_phone">
                                                    <svg class="bi bi-phone  mr-1 text-primary" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11 1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path fill-rule="evenodd" d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>
                                                    {{details.contact_phone}}<br>
                                                </span> 
                                                <small v-if="details.property_contact_text" class="text-black-50">{{details.property_contact_text}}</small>
                                                <small v-if="details.flag_contact_form" class="text-black-50">Fill out the form above or call for more information.</small>
                                                <small v-else class="text-black-50">Call for more information.</small>
                                            </span>
                                    </div>
                                    <!-- Description Texts -->
                                    <div class="mb-5">

                                        <h5>Description</h5> <hr class="m-0">
                                        <span v-if="details.property_description===null">Call for more up to date information.</span>
                                        <span v-else>
                                            {{details.property_description.substring(0,readmore.propertyDetails)}}
                                            <p v-if="details.property_description.length>355" class="mt-2">
                                                <button v-on:click="readmore.propertyDetails=details.property_description.length" class="btn btn-sm btn-link">Read more...</button>
                                            </p>
                                        </span>

                                        <div v-if="details.property_description_repair" class="pt-3">
                                        <h5>Repairs Description</h5> <hr class="m-0">
                                            <p>
                                                {{details.property_description_repair.substring(0,readmore.propertyRepairs)}}
                                            </p>
                                            <p v-if="details.property_description_repair.length>355" class="mt-2">
                                                <button v-on:click="readmore.propertyRepairs=details.property_description_repair.length" class="btn btn-sm btn-link">Read more...</button>
                                            </p>
                                        </div>

                                        <div v-if="details.property_description_other" class="pt-3">
                                            <h5>Other Description</h5> <hr class="m-0">
                                            <p>
                                                {{details.property_description_other.substring(0,readmore.propertyOther)}}
                                            </p>
                                            <p v-if="details.property_description_other.length>355" class="mt-2">
                                                <button v-on:click="readmore.propertyOther=details.property_description_other.length" class="btn btn-sm btn-link">Read more...</button>
                                            </p>
                                        </div>

                                        <p class="pt-5">
                                            <small class="text-muted"><img src="https://www.reallyworkscrm.com/images/logo.gif" height="23px;" alt="Really Works Systems" class="mr-2">Data powered by <a href="https://www.reallyworkscrm.com">Really Works CRM</a> &copy;2020. All rights reserved.</small>
                                        </p>

                                    </div>
                                </div>
                                <!-- Accordian -->
                                <div class="col-md-12 col-sm-12 col-lg-6">
                                   <div class="accordion" id="detailsAccordion">
                                       <div class="card border-0">
                                           <div class="card-header bg-white" id="headingZero">
                                               <h2 class="mb-0">
                                                   <button class="p-0 btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseZero" aria-expanded="true" aria-controls="collapseOne">
                                                       Financial Data
                                                       <span class="float-right"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-wallet2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M2.5 4l10-3A1.5 1.5 0 0 1 14 2.5v2h-1v-2a.5.5 0 0 0-.5-.5L5.833 4H2.5z"/>
                                                          <path fill-rule="evenodd" d="M1 5.5A1.5 1.5 0 0 1 2.5 4h11A1.5 1.5 0 0 1 15 5.5v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-8zM2.5 5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-11z"/>
                                                        </svg></span>
                                                   </button>
                                               </h2>
                                           </div>
                                           <div id="collapseZero" class="collapse" :class="{'show': details.financials_property_price_rent||details.financials_price_sale||details.financials_property_repairs_price||details.financials_after_repair_value||details.financials_tax_assessed_value||details.financials_annual_taxes||details.financials_annual_insurance}" aria-labelledby="headingZero" data-parent="#detailsAccordion">
                                               <div class="card-body">
                                                   <div class="col" v-if="details.financials_property_price_rent||details.financials_price_sale||details.financials_property_repairs_price||details.financials_after_repair_value||details.financials_tax_assessed_value||details.financials_annual_taxes||details.financials_annual_insurance">
                                                       <table class="table table-sm table-borderless">
                                                           <thead>
                                                           </thead>
                                                           <tbody>
                                                           <tr v-if="details.financials_asking_price>0"><td class="">Asking Price:</td> <td>{{details.financials_asking_price|currency}}</td></tr>
                                                           <tr v-if="details.financials_property_price_rent>0"><td class="">Est. Rent:</td> <td>{{details.financials_property_price_rent|currency}}</td></tr>
                                                           <tr v-if="details.financials_annual_insurance>0"><td class="">Annual Insurance:</td> <td>{{details.financials_annual_insurance|currency}}</td></tr>
                                                           <tr v-if="details.financials_annual_taxes>0"><td class="">Annual Taxes:</td> <td>{{details.financials_annual_taxes|currency}}</td></tr>
                                                           <tr v-if="details.financials_after_repair_value>0"><td class="">Est. After Repair value (ARV):</td> <td>{{details.financials_after_repair_value|currency}}</td></tr>
                                                           <tr v-if="details.financials_property_repairs_price>0"><td class="">Est. Cost of Repairs:</td> <td>{{details.financials_property_repairs_price|currency}}</td></tr>
                                                           <tr v-if="details.financials_price_sale>0"><td class="">Last Sold For:</td> <td>{{details.financials_price_sale|currency}}</td></tr>
                                                           <tr v-if="details.financials_tax_assessed_value>0"><td class="">Tax Assessed Value:</td> <td >{{details.financials_tax_assessed_value|currency}}</td></tr>
                                                           </tbody>
                                                       </table>
                                                       <small class="text-black-50">Please contact us for the most up to date details. Estimates and values may change without notice. Due diligence is required. </small>
                                                   </div>
                                                   <div class="row" v-else>
                                                       <div class="col">Contact us for additional financial details.</div>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                        <div class="card border-0">
                                        <div class="card-header bg-white" id="headingOne">
                                            <h2 class="mb-0">
                                            <button class="p-0 btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Property Features
                                                <span class="float-right"><svg class="bi bi-house" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                                                <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
                                                </svg></span>
                                            </button>
                                            </h2>
                                        </div>
                                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#detailsAccordion">
                                            <div class="card-body">
                                                <div class="row" v-if="validatePropertyFeatures()">
                                                    <div class="col-4" v-if="details.f_p_centralac">Central AC</div>
                                                    <div class="col-4" v-if="details.f_p_centralheat">Central Heat</div>
                                                    <div class="col-4" v-if="details.f_p_fireplace">Fire place</div>
                                                    <div class="col-4" v-if="details.f_p_highvaultceiling">High vaulted ceiling</div>
                                                    <div class="col-4" v-if="details.f_p_walkincloset">Walk in closet</div>
                                                    <div class="col-4" v-if="details.f_p_hardwoodfloor">Hardwood floor</div>
                                                    <div class="col-4" v-if="details.f_p_tilefloor">Tile floor</div>
                                                    <div class="col-4" v-if="details.f_p_familyroom">Family room</div>
                                                    <div class="col-4" v-if="details.f_p_livingroom">Living room</div>
                                                    <div class="col-4" v-if="details.f_p_bonusrecroom">Bonus/Rec room</div>
                                                    <div class="col-4" v-if="details.f_p_officeden">Office den</div>
                                                    <div class="col-4" v-if="details.f_p_dinningroom">Dinning room</div>
                                                    <div class="col-4" v-if="details.f_p_breakfastnook">Breakfast nook</div>
                                                    <div class="col-4" v-if="details.f_p_dishwasher">Dish washer</div>
                                                    <div class="col-4" v-if="details.f_p_garbasedisposal">Garbage disposal</div>
                                                    <div class="col-4" v-if="details.f_p_refrigerator">Refrigerator</div>
                                                    <div class="col-4" v-if="details.f_p_stoveoven">Stove/Oven</div>
                                                    <div class="col-4" v-if="details.f_p_microwave">Microwave</div>
                                                    <div class="col-4" v-if="details.f_p_granitecountertop">Granite counter tops</div>
                                                    <div class="col-4" v-if="details.f_p_stainlesssteelappliances">Stainless steel appliances</div>
                                                    <div class="col-4" v-if="details.f_p_attic">Attic</div>
                                                    <div class="col-4" v-if="details.f_p_basement">Basement</div>
                                                    <div class="col-4" v-if="details.f_p_washer">Washer</div>
                                                    <div class="col-4" v-if="details.f_p_dryer">Dryer</div>
                                                    <div class="col-4" v-if="details.f_p_deepfreezer">Deep freezer</div>
                                                    <div class="col-4" v-if="details.f_p_laundryareainside">Inside laundry</div>
                                                    <div class="col-4" v-if="details.f_p_laundryareaoutside">Outside laundry</div>
                                                    <div class="col-4" v-if="details.f_p_balconydeckpatio">Balcony/Patio/Deck</div>
                                                    <div class="col-4" v-if="details.f_p_yard">Yard</div>
                                                    <div class="col-4" v-if="details.f_p_swimmingpool">Swimming pool</div>
                                                    <div class="col-4" v-if="details.f_p_jacuzziwhirlpool">Jazzuzi</div>
                                                    <div class="col-4" v-if="details.f_p_sauna">Sauna</div>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col">None available.</div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="card border-0">
                                        <div class="card-header bg-white" id="headingTwo">
                                            <h2 class="mb-0">
                                            <button class="p-0 btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Map &amp; Location Features
                                                <span class="float-right"><svg class="bi bi-map" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M15.817.613A.5.5 0 0 1 16 1v13a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 14.51l-4.902.98A.5.5 0 0 1 0 15V2a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0l4.902.98 4.902-.98a.5.5 0 0 1 .415.103zM10 2.41l-4-.8v11.98l4 .8V2.41zm1 11.98l4-.8V1.61l-4 .8v11.98zm-6-.8V1.61l-4 .8v11.98l4-.8z"/>
                                                </svg></span>
                                            </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#detailsAccordion">
                                            <div class="card-body">
                                                <div class="row"><img :src="apiUrl+'api/v1/listing/map/image?long='+details.property_longitude+'&lat='+details.property_latitude" alt="Map image"></div>
                                                <div class="row" v-if="validateLocationFeatures()">
                                                    <div class="col-4" v-if="details.f_l_cornerlot">Corner lot</div>
                                                    <div class="col-4" v-if="details.f_l_ongolfcourse">On golf course</div>
                                                    <div class="col-4" v-if="details.f_l_citylightsview">City lights</div>
                                                    <div class="col-4" v-if="details.f_l_oceanview">Ocean view</div>
                                                    <div class="col-4" v-if="details.f_l_riverview">River view</div>
                                                    <div class="col-4" v-if="details.f_l_waterview">Water view</div>
                                                    <div class="col-4" v-if="details.f_l_gardenview">Garden view</div>
                                                    <div class="col-4" v-if="details.f_l_hllsideview">Hill view</div>
                                                    <div class="col-4" v-if="details.f_l_culdesac">Culdesac</div>
                                                    <div class="col-4" v-if="details.f_l_waterfront">Water front</div>
                                                    <div class="col-4" v-if="details.f_l_mountainview">Mountain view</div>
                                                    <div class="col-4" v-if="details.f_l_lotprivate">Private lot</div>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col">No additional details available.</div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="card border-0">
                                            <div class="card-header bg-white" id="headingThree">
                                            <h2 class="mb-0">
                                                <button class="p-0 btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                    Utility/Access Features
                                                    <span class="float-right"><svg class="bi bi-tools" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M0 1l1-1 3.081 2.2a1 1 0 0 1 .419.815v.07a1 1 0 0 0 .293.708L10.5 9.5l.914-.305a1 1 0 0 1 1.023.242l3.356 3.356a1 1 0 0 1 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-3.356-3.356a1 1 0 0 1-.242-1.023L9.5 10.5 3.793 4.793a1 1 0 0 0-.707-.293h-.071a1 1 0 0 1-.814-.419L0 1zm11.354 9.646a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708-.708l-3-3z"/>
                                                    <path fill-rule="evenodd" d="M15.898 2.223a3.003 3.003 0 0 1-3.679 3.674L5.878 12.15a3 3 0 1 1-2.027-2.027l6.252-6.341A3 3 0 0 1 13.778.1l-2.142 2.142L12 4l1.757.364 2.141-2.141zm-13.37 9.019L3.001 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
                                                    </svg></span>
                                                </button>
                                            </h2>
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#detailsAccordion">
                                            <div class="card-body">
                                                <div class="row" v-if="validateUtilAccessFeatures()">
                                                    <div class="col-4" v-if="details.f_c_grageparking">Garage parking</div>
                                                    <div class="col-4" v-if="details.f_c_coveredparking">Covered parking</div>
                                                    <div class="col-4" v-if="details.f_c_guestparking">Guest parking</div>
                                                    <div class="col-4" v-if="details.f_c_businesscenter">Business center</div>
                                                    <div class="col-4" v-if="details.f_c_clubhouse">Club house</div>
                                                    <div class="col-4" v-if="details.f_c_laundryonsite">Onsite laundry</div>
                                                    <div class="col-4" v-if="details.f_c_storagespace">Storage space</div>
                                                    <div class="col-4" v-if="details.f_c_fitnesscenter">Fitness center</div>
                                                    <div class="col-4" v-if="details.f_c_swimmingpool">Swimming pool</div>
                                                    <div class="col-4" v-if="details.f_c_saunaspa">Sauna/Spa</div>
                                                    <div class="col-4" v-if="details.f_c_tenniscourt">Tennis court</div>
                                                    <div class="col-4" v-if="details.f_c_golfcourse">Golf course</div>
                                                    <div class="col-4" v-if="details.f_c_lake">Lake</div>
                                                    <div class="col-4" v-if="details.f_c_playground">Playground</div>
                                                    <div class="col-4" v-if="details.f_c_gatedproperty">Gated property</div>
                                                    <div class="col-4" v-if="details.f_c_securedentry">Secured entry</div>
                                                    <div class="col-4" v-if="details.f_c_elevator">Elevator</div>
                                                    <div class="col-4" v-if="details.f_c_wheelchairaccess">Accessible</div>
                                                    <div class="col-4" v-if="details.f_u_internet">Internet</div>
                                                    <div class="col-4" v-if="details.f_u_tv">TV</div>
                                                    <div class="col-4" v-if="details.f_u_cable">Cable</div>
                                                    <div class="col-4" v-if="details.f_u_satellite">Satelite</div>
                                                    <div class="col-4" v-if="details.f_u_hoafees">HOA fees</div>
                                                </div>
                                                <div class="row" v-else>
                                                <div class="col">None available.</div>
                                            </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card border-0">
                                        <div class="card-header bg-white" id="headingFour">
                                            <h2 class="mb-0">
                                                <button class="p-0 btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                    Links &amp; Internet Resources
                                                    <span class="float-right"><svg class="bi bi-link-45deg" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M4.715 6.542L3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.001 1.001 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/><path d="M5.712 6.96l.167-.167a1.99 1.99 0 0 1 .896-.518 1.99 1.99 0 0 1 .518-.896l.167-.167A3.004 3.004 0 0 0 6 5.499c-.22.46-.316.963-.288 1.46z"/><path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 0 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 0 0-4.243-4.243L6.586 4.672z"/><path d="M10 9.5a2.99 2.99 0 0 0 .288-1.46l-.167.167a1.99 1.99 0 0 1-.896.518 1.99 1.99 0 0 1-.518.896l-.167.167A3.004 3.004 0 0 0 10 9.501z"/></svg></span>
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" :class="{'show': validatePropertyLinks()}" aria-labelledby="headingFour" data-parent="#detailsAccordion">
                                            <div class="card-body">
                                                <div class="row" v-if="validatePropertyLinks()">
                                                    <ul>
                                                        <li v-if="details.property_url_1"><a :href="details.property_url_1" target="_blank">{{details.property_url_label_1||details.property_url_1}}</a></li>
                                                        <li v-if="details.property_url_2"><a :href="details.property_url_2" target="_blank">{{details.property_url_label_2||details.property_url_2}}</a></li>
                                                        <li v-if="details.property_url_3"><a :href="details.property_url_3" target="_blank">{{details.property_url_label_3||details.property_url_3}}</a></li>
                                                        <li v-if="details.property_url_4"><a :href="details.property_url_4" target="_blank">{{details.property_url_label_4||details.property_url_4}}</a></li>
                                                        <li v-if="details.property_url_5"><a :href="details.property_url_5" target="_blank">{{details.property_url_label_5||details.property_url_5}}</a></li>
                                                    </ul>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col">None available.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-0">
                                        <div class="card-header bg-white" id="headingFive">
                                        <h2 class="mb-0">
                                            <button class="p-0 btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFour">
                                            Other
                                            <span class="float-right"><svg class="bi bi-list-ul" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                            </svg></span>
                                            </button>
                                        </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#detailsAccordion">
                                        <div class="card-body">
                                            Other details are not available.
                                        </div>
                                        </div>
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>

            <!-- Login -->
            <Login :api="apiUrl" :location="location" :expired="expired" />

            <!-- Newsletter Management -->
            <Newsletter :api="apiUrl" :location="location" :opt_in_daily="payload.preferences.opt_in_daily" :opt_in_weekly="payload.preferences.opt_in_weekly" :opt_in_monthly="payload.preferences.opt_in_monthly" :opt_in_yearly="payload.preferences.opt_in_yearly" />

            <!-- Footer -->
            <footer class="pt-4 my-md-5 pt-md-5 border-top">
                    <div class="row">
                        <div class="col mb-3">
                            <div class="media">

                                <img v-if="payload.company.logo" height="70px" class="mr-3" :src="payload.company.logo" alt="Logo">

                                <div class="media-body">
                                    <h5 class="mt-0">{{payload.company.label}}</h5>
                                    {{payload.company.address}}, {{payload.company.city}} {{payload.company.state}} {{payload.company.zip}}
                                    <br>
                                    <span v-if="payload.company.email">
                                    <svg class="bi bi-envelope mr-2 text-primary" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M14 3H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M.05 3.555C.017 3.698 0 3.847 0 4v.697l5.803 3.546L0 11.801V12c0 .306.069.596.192.856l6.57-4.027L8 9.586l1.239-.757 6.57 4.027c.122-.26.191-.55.191-.856v-.2l-5.803-3.557L16 4.697V4c0-.153-.017-.302-.05-.445L8 8.414.05 3.555z"/></svg>
                                    <a class="text-muted" :href="payload.company.email">{{payload.company.email}}</a>
                                    <span class="mx-2 text-muted">|</span>
                                    </span>
                                    <span v-if="payload.company.www">
                                    <svg v-if="payload.company.www" class="bi bi-cloud mr-2 text-primary" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.887 7.2l-.964-.165A2.5 2.5 0 1 0 3.5 12h10a1.5 1.5 0 0 0 .237-2.981L12.7 8.854l.216-1.028a4 4 0 1 0-7.843-1.587l-.185.96zm9.084.341a5 5 0 0 0-9.88-1.492A3.5 3.5 0 1 0 3.5 13h9.999a2.5 2.5 0 0 0 .394-4.968c.033-.16.06-.324.077-.49z"/></svg>
                                    <a class="text-muted" :href="payload.company.www">{{payload.company.www}}</a>
                                    <span class="mx-2 text-muted">|</span>
                                    </span>
                                    <span v-if="payload.company.phone">
                                    <svg class="bi bi-phone mr-2 text-primary" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11 1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path fill-rule="evenodd" d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>
                                    <a :href="'tel:'+payload.company.phone">{{payload.company.phone}}</a>
                                    </span>
                                    <br>
                                    <span>
                                    <svg class="bi bi-newspaper mr-2 text-primary" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M0 2A1.5 1.5 0 0 1 1.5.5h11A1.5 1.5 0 0 1 14 2v12a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 14V2zm1.5-.5A.5.5 0 0 0 1 2v12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-11z"/><path fill-rule="evenodd" d="M15.5 3a.5.5 0 0 1 .5.5V14a1.5 1.5 0 0 1-1.5 1.5h-3v-1h3a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 1 .5-.5z"/><path d="M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"/></svg>
                                    <a v-on:click="manageNewsletter()" href="#">Manage my newsletter subscription</a>
                                    </span>
                                  <p class="pt-3">
                                    <small class="text-muted">Data powered by <a href="https://www.reallyworkscrm.com">Really Works CRM</a> &copy;2020. All rights reserved.</small>
                                  </p>
                                </div>
                            </div>
                        </div>
                        <div v-if="payload.links" class="col-lg-3 col-md-3 col-sm-12 mb-3">
                            <h5 v-if="payload.links.facebook||payload.links.linkedin||payload.links.slack||payload.links.skype||payload.links.instagram"
                            class="text-center">Find us on social media</h5>
                            <ul v-if="payload.links" class="list-unstyled list-inline text-small text-center">
                                <span v-if="payload.links.facebook" class="m-2"><a class="text-muted" href="#"
                                                                                   target="_blank"><i
                                        class="fab fa-2x fa-facebook" style="color: steelblue"></i></a></span>
                                <span v-if="payload.links.linkedin" class="m-2"><a class="text-muted" href="#"
                                                                                   target="_blank"><i
                                        class="fab fa-2x fa-linkedin" style="color: steelblue"></i></a></span>
                                <span v-if="payload.links.instagram" class="m-2"><a class="text-muted" href="#"
                                                                                    target="_blank"><i
                                        class="fab fa-2x fa-instagram" style="color: steelblue"></i></a></span>
                                <span v-if="payload.links.slack" class="m-2"><a class="text-muted" href="#"
                                                                                target="_blank"><i
                                        class="fab fa-2x fa-slack" style="color: steelblue"></i></a></span>
                                <span v-if="payload.links.skype" class="m-2"><a class="text-muted" href="#"
                                                                                target="_blank"><i
                                        class="fab fa-2x fa-skype" style="color: steelblue"></i></a></span>
                            </ul>
                        </div>
                    </div>
                </footer>

        </div>

    </div>
</template>

<script>
     //import HelloWorld from './components/HelloWorld.vue'
    import $ from "jquery";
    import Login from "@/components/Login";
    import Newsletter from "@/components/Newsletter";
    //window.$ = window.jQuery = $;
    window.$ = $ = window.jQuery; //?
    import axios from 'axios';
    const filterPrice = (filters, properties) => {
        let price = properties.filter(r => Number(r.property_price_sale) >= Number(filters.price));
        let room = price.filter(r => r.property_rooms >= filters.rooms);
        let bath = room.filter(r => r.property_bathrooms >= filters.baths);
        if (filters.type == 99) { return bath; } //no need to filter
        let type = bath.filter(r => r.property_type == filters.type);
        return type;
    };
    const filterRooms = (filters, properties) => {
        let price = properties.filter(r => Number(r.property_price_sale) >= Number(filters.price));
        let room = price.filter(r => r.property_rooms >= filters.rooms);
        let bath = room.filter(r => r.property_bathrooms >= filters.baths);
        if (filters.type == 99) { return bath; } //no need to filter
        let type = bath.filter(r => r.property_type == filters.type);
        return type;
    };
    const filterBaths = (filters, properties) => {
        let price = properties.filter(r => Number(r.property_price_sale) >= Number(filters.price));
        let room = price.filter(r => r.property_rooms >= filters.rooms);
        let bath = room.filter(r => r.property_bathrooms >= filters.baths);
        if (filters.type == 99) { return bath; } //no need to filter
        let type = bath.filter(r => r.property_type == filters.type);
        return type;
    };
    const filterTypes = (filters, properties) => {
        let price = properties.filter(r => Number(r.property_price_sale) >= Number(filters.price));
        let room = price.filter(r => r.property_rooms >= filters.rooms);
        let bath = room.filter(r => r.property_bathrooms >= filters.baths);
        if (filters.type == 99) { return bath; } //no need to filter
        let type = bath.filter(r => r.property_type == filters.type);
        return type;
    };
    
    export default {
        name: 'Home',
        components: {
            Login,
            Newsletter
        },
        data: () => ({
            alert: {
                subscribed: false,
            },
            cookie: false,
            counter: 0, // Counter for filtered property results
            demo: true,
            details: null, // {} property detail object with all the info of a specific property
            errors: {
                name: null,
                phone: null,
                email: null,
            },
            expired: false,
            filters: {
                baths: 0,
                price: 0.01,
                rooms: 0,
                type: 99,
            },
            homedetails: null,
            ip: null,
            location: null,
            payload: {
                company: {
                    label: '',
                    phone: '301-302-6907',
                    email: 'info@acmeexample.org',
                    address: '12345 Acme Acres Ave #6, Los Angeles CA, 90210',
                    www: 'https://www.example.org/'
                },
                domain: 'www.testing.local',
                header: null,
                html: {sample: null},
                preferences: {leads: null},
                subheader: null,
                tag: 'testing123',
            },
            property: {
                company: null,
                company_logo: null,
                contactee: null,
                slug: null,
                property_address: null,
                url_image_primary: null,
                property_city: null,
                property_state: null,
                property_zip: null,
                property_headline_1: null,
                property_headline_2: null,
                property_headline_3: null,
                property_price_sale: null,
                property_rooms: null,
                property_bathrooms: null,
                property_sq_ft: null,
                property_type: null,
                created_at: null,
                imgCsv: null,
            },
            readmore: {
                propertyDetails: 355,
                propertyRepairs: 355,
                propertyOther: 355,
            },
            request: {
                name : null,
                email: null,
                phone: null,
                appointment: null,
                additional: null,
                location: null,
                message: null,
                property: null,
                ip: null,
                cid: null,
                rw_cid: null,
                rw_n: null,
            },
            store: null,
            subscriber: {
                ok: false,
                name: null,
                last: null, // honey pot
                company: null,
                city: null,
                state: null,
                email: null,
                phone: null,
                source: null,
                location: null,
                interest: {
                    buyer: true,
                    seller: false,
                    lender: false,
                    other: false
                },
                newsletter: {
                    daily: false,
                    weekly: false,
                    monthly: false,
                    yearly: false,
                }
            },
            subscriberErrors: {},
            thankYou: false,
            thankYouSubscriber: false,
            toggledView: false,
        }),
        methods: {
            findPrice() {
                this.store = this.payload.properties;
                let temp = new Set(filterPrice(this.filters, this.store));
                this.store = Array.from(temp); this.counter = this.store.length;
            },
            findRooms() {
                this.store = this.payload.properties;
                let temp = new Set(filterRooms(this.filters, this.store));
                this.store = Array.from(temp); this.counter = this.store.length;
            },
            findBaths() {
                this.store = this.payload.properties;
                let temp = new Set(filterBaths(this.filters, this.store));
                this.store = Array.from(temp); this.counter = this.store.length;
            },
            findType() {
                this.store = this.payload.properties;
                let temp = new Set(filterTypes(this.filters, this.store));
                this.store = Array.from(temp); this.counter = this.store.length;
            },
            getHomeDetails() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                this.homedetails = urlParams.get('homedetails');
                // -----------console.info('zillow? '+this.homedetails);
                // Set details to display if homedetails was previously set in the url params
                if (urlParams.get('homedetails')) this.getProperty(urlParams.get('homedetails'));
            },
            getIp() {
                axios.get('https://jsonip.com/').then((res) => { 
                    this.storeVisit(res.data.ip); this.ip=res.data.ip;
                });
            },
            getProperties() {
                // Default: https://l.rlyw.xyz/{www.domain.xyz}.json
                // Origin: https://rlywxyzlist.azureedge.net/{www.domain.xyz}.json
                // l.rlyw.xyz -> rlywxyzlist.azureedge.net
                axios.get(this.location + '.json?t='+Date.now()).then((res) => {
                    this.payload = res.data;
                    this.store = res.data.properties;
                    this.counter = res.data.properties.length;
                 })
                .then(()=>{
                    // Get and set 'homedetails' if set in query parameter // http://localhost:8080/?homedetails=11542-Sedgemoore-Dr-E-Jacksonville-FL-33320, localhost:8080?homedetails=0610-Crownhardt-Center-Washington-DC-31565
                    // Get local storage items for verification
                    const rw_l = localStorage.getItem('rw_l');
                    const rw_x = localStorage.getItem('rw_x');
                    const rw_auth = localStorage.getItem('rw_auth');
                    const rw_cid = localStorage.getItem('rw_cid');
                    // if local storage keys are present then they are a subscriber (if not then there should be no popups)
                    if (rw_l&&rw_x&&rw_auth&&rw_cid) this.getHomeDetails();
                    // Set Facebook metadata content to index.html
                    document.querySelector('meta[property="og:url"]').setAttribute("content", window.location.href);
                    document.querySelector('meta[property="og:title"]').setAttribute("content", this.payload.company.label);
                    const description = (this.payload.header) ? this.payload.header : 'Real estate investment property for sale.';
                    document.querySelector('meta[property="og:description"]').setAttribute("content", description);
                    const firstImage = (this.store[0].imgcsv===null) ? null : this.store[0].imgcsv.split(',');
                    const fbMetaImage = (firstImage===null) ? this.store[0].url_image_primary : firstImage[0];
                    //console.log(firstImage);
                    //console.log(fbMetaImage);
                    document.querySelector('meta[property="og:image"]').setAttribute("content", fbMetaImage);
                    // If query params exist then show
                    setTimeout(() => {
                        this.getPropertyFromQueryParam();
                    }, 1500)
                })
                .catch((err) => {
                    console.log(err); /*window.location = 'https://www.google.com';*/
                });

            },
            getProperty(property, slug) {

                // If users are allowed to view properties without subscribing/logging in then set toggleView to true and continue
                if (this.payload.preferences.leads===false) this.toggledView=true;

                if (this.toggledView) {

                  this.property=property;

                    // If subscription/leads are not required then set this.toggleView to true during mounting
                    // Find property slug
                    const index = this.payload.properties.findIndex(p => p.slug === slug);
                    if (index === -1) return;

                    // Cache/placeholder text for per-property mini-forms
                    if (localStorage.getItem('rw_sub_n')) this.request.name = localStorage.getItem('rw_sub_n');
                    if (localStorage.getItem('rw_sub_e')) this.request.email = localStorage.getItem('rw_sub_e');
                    if (localStorage.getItem('rw_sub_p')) this.request.phone = localStorage.getItem('rw_sub_p');

                    // Set details variable to the found:index to avoid mutating (you couldnt anyways cuz its a static json file)
                    this.details = this.payload.properties[index];

                    // Get variables for modal header
                    this.property.company = this.payload.company.label; // set
                    this.property.company_logo = this.payload.company.logo; // set
                    
                    // Get variables for property info and contact boxes
                    document.title = this.details.property_address + ' ' + this.details.property_city + ' ' + this.details.property_state + ' ' + this.details.property_zip; // Set browser title
                    this.request.message = "I'd like more information on " + this.details.property_address + ' ' + this.details.property_city + ' ' + this.details.property_state + ' ' + this.details.property_zip + '.';
                    this.request.property = this.details.slug;
                    //this.details.map = '//' + document.getElementById('google').value + '/map?id=' + this.details.address + ' ' + this.details.city + ' ' + this.details.state + ' ' + this.details.zip;

                    // Trigger modal if homedetails is set/was previously set
                    setTimeout(()=>{ $("#viewPropertyModal").modal("show"); }, 1000);

                    // Record visits if certain data is set (ie: localStorage)
                    let email = localStorage.getItem('rw_e');
                    let name = localStorage.getItem('rw_n');
                    let cid = localStorage.getItem('rw_cid')?localStorage.getItem('rw_cid'):null;
                    if (email||name||cid) {
                        axios.post(this.apiUrl + 'api/v1/listing/view', {
                            data: {rw_cid: cid, rw_s: slug, rw_l: this.location, rw_a: this.ip}
                        }).catch((err) => { console.error(err); console.error('Error processing property nudge request.'); })
                    }
                }
            },
            getPropertyFromQueryParam() {
                this.getHomeDetails();
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const homedetails = urlParams.get('homedetails');

                const found = this.payload.properties.findIndex(p =>  p.slug.toString() == homedetails);
                if (found !== -1) {
                    this.property = this.payload.properties[found];
                }
                
                // const property = this.store[found];

                // If users are allowed to view properties without subscribing/logging in then set toggleView to true and continue
                if (this.payload.preferences.leads===false) this.toggledView=true;

                if (this.toggledView && found) {

                    // If subscription/leads are not required then set this.toggleView to true during mounting
                    // Find property slug
                    const index = this.payload.properties.findIndex(p => p.slug === this.homedetails);
                    if (index === -1) return;

                    // Cache/placeholder text for per-property mini-forms
                    if (localStorage.getItem('rw_sub_n')) this.request.name = localStorage.getItem('rw_sub_n');
                    if (localStorage.getItem('rw_sub_e')) this.request.email = localStorage.getItem('rw_sub_e');
                    if (localStorage.getItem('rw_sub_p')) this.request.phone = localStorage.getItem('rw_sub_p');

                    // Set details variable to the found:index to avoid mutating (you couldnt anyways cuz its a static json file)
                    this.details = this.payload.properties[index];

                    // Get variables for modal header
                    this.property.company = this.payload.company.label; // set
                    this.property.company_logo = this.payload.company.logo; // set
                    
                    // Get variables for property info and contact boxes
                    document.title = this.details.property_address + ' ' + this.details.property_city + ' ' + this.details.property_state + ' ' + this.details.property_zip; // Set browser title
                    this.request.message = "I'd like more information on " + this.details.property_address + ' ' + this.details.property_city + ' ' + this.details.property_state + ' ' + this.details.property_zip + '.';
                    this.request.property = this.details.slug;
                    //this.details.map = '//' + document.getElementById('google').value + '/map?id=' + this.details.address + ' ' + this.details.city + ' ' + this.details.state + ' ' + this.details.zip;

                    // Trigger modal if homedetails is set/was previously set
                    setTimeout(()=>{ $("#viewPropertyModal").modal("show"); }, 1500);

                    // Record visits if certain data is set (ie: localStorage)
                    let email = localStorage.getItem('rw_e');
                    let name = localStorage.getItem('rw_n');
                    let cid = localStorage.getItem('rw_cid')?localStorage.getItem('rw_cid'):null;
                    if (email||name||cid) {
                        axios.post(this.apiUrl + 'api/v1/listing/view', {
                            data: {rw_cid: cid, rw_s: this.homedetails, rw_l: this.location, rw_a: this.ip}
                        }).catch((err) => { console.error(err); console.error('Error processing property nudge request.'); })
                    }
                }
            },
            getPropertyMap() {
                // Build map image from property detail longitude and latitude
                if (this.details)
                {
                    axios.get(this.apiUrl + 'api/v1/listing/map/image', { params: {long: this.details.property_longitude, lat: this.details.property_latitude}})
                    .then((res)=>{return res.data});
                }
            },
            getPropertyAfterSubscribing() {
                // If a subscriber subscribed in order to look at an existing property (already
                // set in the homedetails url parameter, then trigger the modal here
                if (this.homedetails !== "" && this.toggledView) {
                    //now subscribed so show modal
                    this.getProperties();
                }
            },
            manageNewsletter() {
                $('#newsletters').modal('show');
            },
            refreshBrowser()
            {
              console.info("Solid.");
                setTimeout(()=>{ location.href = 'welcome'; return false; }, 1500); //this.getProperties();
            },
            resetFilters() {
                this.filters.baths = 0;
                this.filters.price = 0.01;
                this.filters.rooms = 0;
                this.filters.type = 99;
                this.findBaths();
                this.findPrice();
                this.findRooms();
                this.findType();
            },
            togglePropDetailDescription(num=355) {
                if (this.details.property_description===null) {
                    return null;
                } else {
                    return this.details.property_description.substring(0,num);
                }
            },
            toggledViews() {
                // VIew more
                // Set to true to inform that subscription is true and to show all view buttons
                this.toggledView = true;
                // Check to see if homedetails was previously set and toggleview is true. If so show
                // property modal. Typically this is because the browser was sent to a direct link/to view a property
                this.getPropertyAfterSubscribing();
            },
            signIn() {
                $('#registered').modal('show');
            },
            signOut() {
              // Local Storage (prefer to get data from the response to make your life easier)
              localStorage.removeItem('rw_x'); // pre-bust  cache after 1 month
              localStorage.removeItem('rw_e');
              localStorage.removeItem('rw_n');
              localStorage.removeItem('rw_l');
              localStorage.removeItem('rw_auth');
              localStorage.removeItem('rw_cid');
              setTimeout(()=>{
                window.location.href = '&goodbye=ok';
                //window.location.reload(true);
              },500);
            },
            storeRequest() {
                // Post
                this.request.location=this.location;
                this.request.ip=this.ip;
                this.request.cid=(localStorage.getItem('rw_cid')?localStorage.getItem('rw_cid'):null);
                axios.post(this.apiUrl + 'api/v1/listing/request', {data: this.request})
                    .then(()=>{ this.thankYou=true; });
                    //.catch((err) => { console.log(err); });
            },
            storeSubscriber(resend=false, event) {
                let valid = true;

                if (this.subscriber.email===false || this.subscriber.email==="" || this.subscriber.email===null || this.subscriber.email.length < 5)  {
                    valid = false; this.subscriberErrors.email = true;
                }
                if (this.subscriber.name===null || this.subscriber.name.length < 2 || this.subscriber.name.length > 55) {
                    valid = false; this.subscriberErrors.name = true;
                }
                if (this.subscriber.last !== null) {
                    valid = false; // honey pot
                }

                //console.log('validation: '+ valid);
                if (valid) {

                    $("#resend").hide();
                    setTimeout(()=>{ $("#resend").show(); }, 10000);

                   // Random identifier helper
                    // let random = Math.random().toString(36).slice(2);
                    this.thankYouSubscriber = true
                    // Allow View buttons and show Thank you
                    //this.toggledView = true; // <------ depreacted
                    // Post
                    this.subscriber.source = this.ip;
                    this.subscriber.location = this.location;
                    this.subscriber.referrer = (document.referrer) ? document.referrer.split('/')[2] : null;
                    axios.post(this.apiUrl + 'api/v1/listing/subscriber', {data: this.subscriber, resend: resend})
                    .then((res)=>{
                        // Local Storage (prefer to get data from the response to make your life easier)
                        localStorage.setItem('rw_x', Date.now()); // pre-bust  cache after 1 month
                        localStorage.setItem('rw_e', this.subscriber.email);
                        localStorage.setItem('rw_n', this.subscriber.name);
                        localStorage.setItem('rw_l', this.location);
                        localStorage.setItem('rw_auth', 123456789101112131415161); // always ping this
                        localStorage.setItem('rw_cid', res.data.data); // contact_id
                    })
                    .catch((err) => { console.error(err); console.error('Error processing subscription nudge request.'); })

                } else {
                    event.preventDefault();
                }
            },
            storeVisit(ip=null) {
                if (!this.location) return;
                // Record visits at site level
                let cid = localStorage.getItem('rw_cid')?localStorage.getItem('rw_cid'):null;
                let endpoint = this.apiUrl + 'api/v1/listing/visit';
                axios.post(endpoint, { _method: 'post',
                    data: {rw_cid: cid, rw_s: this.location, rw_a: ip}
                }).catch(() => { console.error('Error processing visitor nudge.'); })
            },
            validateAuthentication() {
                // Manage auth key value. If rw_auth is not available (signed in)
                // then expect a user token (authenticating)
                const rw_l = localStorage.getItem('rw_l');
                const rw_auth = localStorage.getItem('rw_auth');
                const rw_cid = localStorage.getItem('rw_cid');

                // Verify that the minimum required local storage keys are set if previously authenticated
                if (rw_l && rw_cid && (rw_auth && rw_auth.length===24))
                {
                    // Trigger getProperties
                    this.demo=false;
                    this.getProperties();
                    return;
                }

                // Manage token query parameter for initial authentication if k:v pairs are not set
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const token = urlParams.get('token');
                // If invalid token is present then return properties and do nothing;
                if (!token||token.length!==64) {
                    console.error("Invalid token provided.");
                    this.getProperties();
                     return; }

                // Retrieve authentication keys
                axios.post(this.apiUrl + 'api/v1/listing/authenticate', {
                    // If you want to capture all this simply move it to a new post and sent the auth details. You cant do it at the time of auth
                    hash: token,
                    location: this.location,
                    ip: this.ip,
                    cid: localStorage.getItem('rw_cid')?localStorage.getItem('rw_cid'):null
                })
                    .then((res)=>{
                        if (res.data.result) {
                            // Local Storage (prefer to get data from the response to make your life easier)
                            localStorage.removeItem('rw_e');
                            localStorage.removeItem('rw_n');
                            localStorage.removeItem('rw_l');
                            localStorage.removeItem('rw_auth');
                            localStorage.removeItem('rw_cid');
                            // set localStorage keys
                            localStorage.setItem('rw_e', res.data.data.email);
                            localStorage.setItem('rw_n', res.data.data.name);
                            localStorage.setItem('rw_l', res.data.data.location);
                            localStorage.setItem('rw_auth', res.data.data.auth); // always ping this
                            localStorage.setItem('rw_cid', res.data.data.contact_id);
                            // Trigger getProperties
                            this.demo=false;
                            // Set Login expired prop to false
                            this.expired=false;
                            // Your authed! Simulate a mouse click so modal can be recalled since its reinserted into the dom. Otherwise the View buttons wont work.
                            setTimeout(()=>{
                              //window.location.href = '&welcome=ok';
                              window.location.reload(true);
                            },1000);
                            //location.replace('http://test.com/sometest.html?myid=5&someotherid=6');
                          //window.location.reload(); // opt 3
                          //history.go(0); // opt 3
                            //this.$router.push('Welcome');
                            // --------->this.$router.go(0);
                            //this.refreshBrowser();
                            //setTimeout(()=>{ window.location.href = 'welcome'; }, 1500); //this.getProperties();
                        } else {
                            // Trigger getProperties (without property object)
                            this.demo=true;
                            this.getProperties();
                            // If a token is set then it by default is considered expired. Notify user.
                            if (token) {
                                // Set Login expired prop to true
                                this.expired = true;
                                // Trigger modal
                                $("#registered").modal("show");
                                //console.log('nope!!!');
                            }
                        }
                    })
                    .catch((err) => { console.log(err); });
            },
            validateConfirmation() {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                //console.info('Confirmed subscriber');
                // Set details to display 'ok''
                if (urlParams.get('confirmed')==='ok') this.alert.subscribed=true;
            },
            validatePropertyFeatures() {
                if (
                    this.details.f_p_centralac||
                    this.details.f_p_centralheat||
                    this.details.f_p_fireplace||
                    this.details.f_p_highvaultceiling||
                    this.details.f_p_walkincloset||
                    this.details.f_p_hardwoodfloor||
                    this.details.f_p_tilefloor||
                    this.details.f_p_familyroom||
                    this.details.f_p_livingroom||
                    this.details.f_p_bonusrecroom||
                    this.details.f_p_officeden||
                    this.details.f_p_dinningroom||
                    this.details.f_p_breakfastnook||
                    this.details.f_p_dishwasher||
                    this.details.f_p_garbasedisposal||
                    this.details.f_p_refrigerator||
                    this.details.f_p_stoveoven||
                    this.details.f_p_microwave||
                    this.details.f_p_granitecountertop||
                    this.details.f_p_stainlesssteelappliances||
                    this.details.f_p_attic||
                    this.details.f_p_basement||
                    this.details.f_p_washer||
                    this.details.f_p_dryer||
                    this.details.f_p_deepfreezer||
                    this.details.f_p_laundryareainside||
                    this.details.f_p_laundryareaoutside||
                    this.details.f_p_balconydeckpatio||
                    this.details.f_p_yard||
                    this.details.f_p_swimmingpool||
                    this.details.f_p_jacuzziwhirlpool||
                    this.details.f_p_sauna
                ) return true;
            },
            validateLocationFeatures() {
                if (
                    this.details.f_l_cornerlot||
                    this.details.f_l_ongolfcourse||
                    this.details.f_l_citylightsview||
                    this.details.f_l_oceanview||
                    this.details.f_l_riverview||
                    this.details.f_l_waterview||
                    this.details.f_l_gardenview||
                    this.details.f_l_hllsideview||
                    this.details.f_l_culdesac||
                    this.details.f_l_waterfront||
                    this.details.f_l_mountainview||
                    this.details.f_l_lotprivate
                ) return true;
            },
            validatePropertyLinks() {
                if (
                    this.details.property_url_1||
                    this.details.property_url_2||
                    this.details.property_url_3||
                    this.details.property_url_4||
                    this.details.property_url_5
                ) return true;
            },
            validateUtilAccessFeatures() {
                if (
                    this.details.f_c_grageparking||
                    this.details.f_c_coveredparking||
                    this.details.f_c_guestparking||
                    this.details.f_c_businesscenter||
                    this.details.f_c_clubhouse||
                    this.details.f_c_laundryonsite||
                    this.details.f_c_storagespace||
                    this.details.f_c_fitnesscenter||
                    this.details.f_c_swimmingpool||
                    this.details.f_c_saunaspa||
                    this.details.f_c_tenniscourt||
                    this.details.f_c_golfcourse||
                    this.details.f_c_lake||
                    this.details.f_c_playground||
                    this.details.f_c_gatedproperty||
                    this.details.f_c_securedentry||
                    this.details.f_c_elevator||
                    this.details.f_c_wheelchairaccess||
                    this.details.f_u_internet||
                    this.details.f_u_tv||
                    this.details.f_u_cable||
                    this.details.f_u_satellite||
                    this.details.f_u_hoafees
                ) return true;
            },
            validateViews() {
                // Allow property view button if certain cache keys are set
                let rw_x = localStorage.getItem('rw_x');
                let rw_l = localStorage.getItem('rw_l');
                let rw_auth = localStorage.getItem('rw_auth');
                let rw_cid = localStorage.getItem('rw_cid');
                if (rw_l&&rw_x&&rw_auth&&rw_cid) {
                    //this.toggledView = true; // Deprecated. Using this.demo now
                    this.demo = false;
                }
            },
            validEmail(email) {
                if (email===null) return;
                let regExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
                return !!email.match(regExp);
                /* if (email.match(regExp)) {
                    return true;
                } else {
                    return false;
                } */
            },
            cookies() {
                // set localStorage cookie keys
                localStorage.setItem('c', true);
                // set flag
                this.cookie=true;
            }
        },
        mounted() {

            if (window.location.host==='localhost:8080') {
                this.apiUrl = 'http://www.really.local/';
                this.location = 'testing123.rlyw.xyz' // Dev:  https://reallyworks.blob.core.windows.net/landings/landing.rlyw.xyz.json
            } else {
                this.apiUrl = 'https://www.reallyworks.xyz/';
                this.location=window.location.host; // Production: www.example.org
            }

            this.validateConfirmation(); // Alert user that email was confirmed

            this.validateViews(); // Toggle view buttons if local storage keys are set

            //this.getProperties(); // Parse payload

            this.validateAuthentication(); // Validate any tokens

            // Set variables for property contact forms, etc...
            this.cookie = (localStorage.getItem('c')) ? localStorage.getItem('c') : false;
            this.request.name = (localStorage.getItem('rw_n')) ? localStorage.getItem('rw_n') : null;
            this.request.email = (localStorage.getItem('rw_e')) ? localStorage.getItem('rw_e') : null;
            this.request.phone = (localStorage.getItem('rw_p')) ? localStorage.getItem('rw_p') : null;
            this.request.cid = (localStorage.getItem('rw_p')) ? localStorage.getItem('rw_p') : null;
            this.request.rw_cid = (localStorage.getItem('rw_cid')) ? localStorage.getItem('rw_cid') : null;
            this.request.rw_n = (localStorage.getItem('rw_n')) ? localStorage.getItem('rw_n') : null;


            // If there is at least an email stored then we will allow the view buttons to show
            if (localStorage.getItem('rw_e')||localStorage.getItem('rw_cid')) this.toggledView = true;

            // Record visitor count
            this.getIp();
        
        },
        computed: {
            computedImageList: function() {
                if (this.property.imgcsv != null) {
                    return this.property.imgcsv.split(',');
                }
                return null;
            },
            computedMapIframe: function() {
                //computedMapIframe: function(lon=0, lat=0) {
                return "//www.bing.com/maps/embed?h=280&w=325&cp=26.714241139280794~-80.08149029500616&lvl=11&typ=d&sty=r&src=SHELL&FORM=MBEDV8";
            },
        }
    }
</script>

<style scoped>
    .email-input {
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom: 1px solid grey;
        margin-bottom: 12px;
    }
    .xcontainer {
        position: relative;
        text-align: center;
        color: white;
    }
    /* Top right text */
    .top-right {
        position: absolute;
        top: 8px;
        right: 16px;
    }
</style>
